import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { TariffRateService } from 'src/app/features/setting/service/tariff-rate.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-tariff-rate-setting-detail',
  templateUrl: './tariff-rate-setting-detail.component.html',
  styleUrls: ['./tariff-rate-setting-detail.component.scss']
})
export class TariffRateSettingDetailComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewTariffRateSetting;

  tariffRate: any;
  forwarderOptions: any[];
  isActivatedOptions: any[];
  isShowEditBtn: boolean;
  isShowCancelBtn: boolean;

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private tariffRateService: TariffRateService
  ) {
    super(injector);
    this.tariffRate =  {};
    this.forwarderOptions = [];
    this.isActivatedOptions = [];
    this.isShowEditBtn = false;
    this.isShowCancelBtn = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.isActivatedOptions = [
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];

    const seqNo = this.routeStateService.getCurrent().data.seqNo;

    try{
      this.tariffRate = await this.tariffRateService.getTariffRateDetail(seqNo);
    }catch (err: any) {
      console.log('get tariff rate occur error: ' + JSON.stringify(err));
    }

    this.facilityService.getForwarderOptions(this.tariffRate.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.isShowEditBtn = true;
    this.isShowCancelBtn = true;
  }

  goToEdit(event: any): void{
    this.routeStateService.navigateTo('/Setting/TariffRateSettingEdit', this.tariffRate);
  }

  goToSearchPage(): void{
    this.routeStateService.navigateTo('/Setting/TariffRateSetting');
  }
}
